export default function validateHex(hex: string) {
  if (hex.charAt(0) !== "#") {
    return `#${hex}`;
  }
  return hex;
}
